import React, { useState, useEffect } from 'react'
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import ResponsiveContainer from 'components/utils/ResponsiveContainer'

const Speakers = ({ list, title }) => {

    const [curPageId, setCurPageId] = useState('')

    useEffect(() => {
        if ( speakers.AE.length ) { 
            setCurPageId('AE')
        } else if ( speakers.FJ.length ) { 
            setCurPageId('FJ')
        } else if ( speakers.KO.length ) { 
            setCurPageId('KO')
        } else if ( speakers.PT.length ) { 
            setCurPageId('PT')
        } else { 
            setCurPageId('UZ')
        }
    },[])

    list.sort((a, b) => a.Name.localeCompare(b.Name, 'es', { sensitivity: 'base' }))
    let data = list.reduce((r, e) => {

        let alphabet = e.Name[0];
        if (!r[alphabet]) r[alphabet] = { alphabet, record: [e] }
        else r[alphabet].record.push(e);
        return r;
    }, {});
       
    let result = Object.values(data);

    const speakers = {
        AE: result.filter( item => item.alphabet === 'A' || item.alphabet === 'B' || item.alphabet === 'C' || item.alphabet === 'D' || item.alphabet === 'E' ),
        FJ: result.filter( item => item.alphabet === 'F' || item.alphabet === 'G' || item.alphabet === 'H' || item.alphabet === 'I' || item.alphabet === 'J' ),
        KO: result.filter( item => item.alphabet === 'K' || item.alphabet === 'L' || item.alphabet === 'M' || item.alphabet === 'N' || item.alphabet === 'O' ),
        PT: result.filter( item => item.alphabet === 'P' || item.alphabet === 'Q' || item.alphabet === 'R' || item.alphabet === 'S' || item.alphabet === 'T' ),
        UZ: result.filter( item => item.alphabet === 'U' || item.alphabet === 'V' || item.alphabet === 'W' || item.alphabet === 'X' || item.alphabet === 'Y' || item.alphabet === 'Z' ),
    }

    const PageButton = ({ children, pageId}) => {
        return <button onClick={ () => setCurPageId(pageId) } className={`px-4 py-2 border-2 border-white border-solid mb-4 font-bold md:mb-0 ${ pageId === curPageId ? 'bg-white text-black' : ''}`}>{ children }</button>
    }
    const AlphaSection = ({ data }) => {
        return (
            <>
                { data.map( item => {
                    return (
                        <div className="mb-16">
                            <span className="border border-solid border-white flex justify-center items-center text-2xl font-bold w-10 h-10 block mb-8">{ item.alphabet }</span>
                            <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-4 xl:grid-cols-5">
                                { item.record.map( speaker => {
                                    const image = getImage(speaker.Photo.localFile)
                                    return (
                                        <div>
                                            <GatsbyImage image={image} alt={speaker.Name} className="w-full" />
                                        </div>
                                    )
                                }) }
                            </div>
                        </div>
                    )
                }) }
            </>
        )
    }
    return (
        <section>
            <ResponsiveContainer className="py-16">
                <div className="flex flex-col border-b border-solid border-white pb-4 mb-8 md:flex-row md:justify-between md:items-center">
                    <div className="text-center mb-4 md:mb-0 md:text-left">
                        <h6 className="text-optician-sans uppercase text-2xl">{ title }</h6>
                    </div>
                    <div className="flex space-x-4 justify-center flex-wrap">
                        { speakers.AE.length > 0 && <PageButton pageId="AE">A - E</PageButton> }
                        { speakers.FJ.length > 0 && <PageButton pageId="FJ">F - J</PageButton> }
                        { speakers.KO.length > 0 && <PageButton pageId="KO">K - O</PageButton> }
                        { speakers.PT.length > 0 && <PageButton pageId="PT">P - T</PageButton> }
                        { speakers.UZ.length > 0 && <PageButton pageId="UZ">U - Z</PageButton> }
                    </div>
                </div>
                { curPageId === 'AE' && <> <AlphaSection data={ speakers.AE } /></>}
                { curPageId === 'FJ' && <> <AlphaSection data={ speakers.FJ } /></>}
                { curPageId === 'KO' && <> <AlphaSection data={ speakers.KO } /></>}
                { curPageId === 'PT' && <> <AlphaSection data={ speakers.PT } /></>}
                { curPageId === 'UZ' && <> <AlphaSection data={ speakers.UZ } /></>}
            </ResponsiveContainer>
        </section>
    )
}

export default Speakers
